module.exports = __webpack_public_path__ + "img/1-1.294d7329.svg";